import { useContext, useState } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import * as SETTINGS from '../../../../constants/settings'
import { SiteConfigContext } from '../../../../context/siteConfigContext'
import { toastSuccess } from '../../../../utils/toast'
import Tooltip from '../../../Utilities/Tooltip'
import './styles.css'

const HeadquartersFree = () => {
  const {
    freeEnabled,
    [SETTINGS.HEADQUARTERS_FREE.key]: freeContent,
    updateSetting
  } = useContext(SiteConfigContext)
  const [tmpGuide, setTmpGuide] = useState(freeContent)

  const handleSubmit = async (e) => {
    e.preventDefault()
    await updateSetting(SETTINGS.HEADQUARTERS_FREE, tmpGuide)
    toastSuccess('Headquarters Free content saved!')
  }

  if (!freeEnabled) {
    return (
      <div className="flex flex-col gap-2">
        <h2>Free mode is not enabled</h2>
      </div>
    )
  }

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      className="flex flex-col gap-2"
    >
      <div className="flex items-center gap-2">
        <h2 className="mr-3">Headquarters Free Content</h2>
        <Tooltip>
          Edit the free mode content displayed on your headquarters page.
        </Tooltip>
      </div>
      <ReactQuill
        id="terms"
        name="terms"
        style={{ height: '420px', width: '100%' }}
        aria-label="Headquarters Free content"
        placeholder="Headquarters Free content"
        defaultValue={freeContent}
        onChange={setTmpGuide}
        modules={{
          toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link'],
            ['clean']
          ]
        }}
        formats={[
          'header',
          'bold',
          'italic',
          'underline',
          'strike',
          'blockquote',
          'list',
          'bullet',
          'link'
        ]}
      />
      <button type="submit" aria-label="Save" className="button-confirm w-fit">
        Save
      </button>
    </form>
  )
}

export default HeadquartersFree
